export default {
  common: {
    continue: 'Continuar',
    back: 'Atrás',
    skip: 'Saltar',
    save: 'Guardar',
    cancel: 'Cancelar',
    loading: 'Cargando…',
    error: 'Algo ha fallado. Reintenta.',
    required: 'Campo obligatorio',
    brandName: 'ininvoice',
    copyright: '© 2026 ININVOICE. Todos los derechos reservados.',
  },
  brand: {
    name: 'ininvoice',
    tagline: 'Paga solo lo que pediste y recibiste.',
  },
  auth: {
    login: { title: 'Inicia sesión', email: 'Email', password: 'Contraseña', submit: 'Entrar', forgot: '¿Has olvidado la contraseña?', noAccount: '¿No tienes cuenta?', createAccount: 'Crear cuenta', googleSignIn: 'Continuar con Google', or: 'o' },
    forgot: { title: 'Recuperar contraseña', hint: 'Te enviamos un enlace para restablecerla.', submit: 'Enviar enlace', backToLogin: 'Volver a inicio de sesión', sent: 'Email enviado. Revisa la bandeja.' },
    reset: { title: 'Nueva contraseña', newPassword: 'Nueva contraseña', confirmPassword: 'Confirmar contraseña', submit: 'Guardar contraseña', success: 'Contraseña actualizada. Vuelve a iniciar sesión.', mismatch: 'Las contraseñas no coinciden' },
    callback: { processing: 'Iniciando sesión…' },
  },
  invitation: {
    heading: "Te han invitado",
    headingSignIn: "Entra para aceptar la invitación",
    title: "Invitación a {org}",
    by: "{who} te invita a aprobar facturas de {org} en ininvoice. Crea tu cuenta con este correo o entra si ya la tienes.",
    anonymous: "Te invitan a aprobar facturas de {org} en ininvoice. Crea tu cuenta con este correo o entra si ya la tienes.",
    emailLocked: "La invitación es para este correo.",
    dead: "Esta invitación no existe, ya se usó o fue retirada. Pide una nueva a quien te invitó.",
  },
  signupHero: {
    email: 'Tu email de trabajo',
    submit: 'Continuar',
    haveAccount: '¿Ya tienes cuenta?',
    signIn: 'Inicia sesión',
    emailRequired: 'El email es obligatorio',
    emailInvalid: 'Email no válido',
  },
  requestAccess: {
    title: 'Solicita acceso',
    body: 'ininvoice funciona por invitación. Si alguien de tu empresa ya lo usa, pídele que te invite; si no, cuéntanos qué necesitas y te damos acceso.',
    cta: 'Solicitar acceso',
    haveAccount: '¿Ya tienes cuenta?',
    signIn: 'Inicia sesión',
  },
  signin: {
    title: 'Bienvenido a ininvoice',
    google: 'Continuar con Google',
    googleLoading: 'Conectando…',
    or: 'o',
    email: 'Email',
    password: 'Contraseña',
    forgot: '¿Olvidaste tu contraseña?',
    submit: 'Iniciar sesión',
    noAccess: '¿Tu empresa aún no usa ininvoice?',
    requestAccess: 'Solicitar acceso',
    invited: '¿Es tu primera vez con esta invitación?',
    createAccount: 'Crea tu cuenta',
    emailRequired: 'El email es obligatorio',
    emailInvalid: 'Email no válido',
    passwordRequired: 'La contraseña es obligatoria',
    errors: {
      credentials: 'Email o contraseña incorrectos. Si entras con Google, usa «Continuar con Google».',
      tooMany: 'Demasiados intentos. Espera unos minutos y vuelve a probar.',
      tooManySeconds: 'Demasiados intentos. Vuelve a probar dentro de {seconds} s.',
      captcha: 'La verificación de seguridad no es válida o ha caducado. Repítela y vuelve a probar.',
      generic: 'No hemos podido iniciar sesión. Inténtalo de nuevo en unos segundos.',
    },
  },
  signup: {
    title: 'Crea tu cuenta',
    subtitle: 'Empieza en minutos.',
    email: 'Email de empresa',
    password: 'Contraseña',
    passwordHint: 'Mínimo 8 caracteres, una mayúscula y un número.',
    accept: 'Acepto los {terms} y la {privacy}.',
    termsLink: 'condiciones de servicio',
    privacyLink: 'política de privacidad',
    submit: 'Crear cuenta',
    haveAccount: '¿Ya tienes cuenta?',
    signIn: 'Inicia sesión',
    rules: {
      emailRequired: 'El email es obligatorio',
      emailInvalid: 'Email no válido',
      passwordRequired: 'La contraseña es obligatoria',
      passwordMin: 'Mínimo 8 caracteres',
      passwordUpper: 'Debe contener al menos una mayúscula',
      passwordDigit: 'Debe contener al menos un número',
      mustAccept: 'Acepta los términos para continuar',
    },
    errors: {
      alreadyHaveAccount: 'Si ya tienes cuenta, entra con tu email y contraseña.',
      passwordWeak: 'La contraseña no cumple los requisitos',
      captcha: 'La verificación de seguridad no es válida o ha caducado. Repítela y vuelve a probar.',
      tooMany: 'Demasiados intentos. Espera unos minutos y vuelve a probar.',
      session: 'La cuenta está creada, pero no hemos podido iniciar sesión. Entra con tu email y contraseña.',
      generic: 'No hemos podido crear la cuenta. Reintenta en unos segundos.',
    },
  },
  forgot: {
    title: 'Recupera tu contraseña',
    hint: 'Escribe tu email y te enviaremos un enlace para elegir una nueva.',
    email: 'Email',
    submit: 'Enviar enlace',
    sentTitle: 'Revisa tu correo',
    sentBody: 'Si hay una cuenta con {email}, en unos minutos te llegará un enlace para restablecer la contraseña.',
    backToSignIn: 'Volver a iniciar sesión',
    emailRequired: 'El email es obligatorio',
    emailInvalid: 'Email no válido',
    errors: {
      tooMany: 'Demasiadas solicitudes. Espera unos minutos y vuelve a probar.',
      tooManySeconds: 'Demasiadas solicitudes. Vuelve a probar dentro de {seconds} s.',
      captcha: 'La verificación de seguridad no es válida o ha caducado. Repítela y vuelve a probar.',
    },
  },
  turnstile: {
    failed: 'No hemos podido cargar la verificación de seguridad. Recarga la página.',
  },
  qualify: {
    title: 'Configura tu cuenta',
    subtitle: 'Adaptamos la app a tu caso. 30 segundos.',
    progress: 'Paso {current} de {total}',
    next: 'Continuar', back: 'Atrás', skip: 'Saltar', finish: 'Entrar a la app',
    error: 'No hemos podido guardar. Reintentando…',
    steps: {
      role:        { title: '¿Cuál es tu rol?', hint: 'Lo usamos para mostrarte primero lo que importa.' },
      companySize: { title: '¿Cuántas personas sois?', hint: 'Empleados totales, no solo el equipo de finanzas.' },
      volume:      { title: '¿Cuántas facturas recibís al mes?', hint: 'Aproximado. Sirve para ajustar el plan.' },
      erp:         { title: '¿Qué usáis hoy para contabilidad?', hint: 'Marca todos los que apliquen. Si no usáis ninguno, marca Excel.' },
      pain:        { title: '¿Qué te trae aquí?', hint: 'Solo lo principal. El resto, después.' },
      callback:    { title: 'Prefiero que me llaméis', hint: 'Te llamamos hoy si lo necesitas.', phoneLabel: 'Teléfono', wantsCall: 'Quiero que me llaméis para verlo en directo' },
    },
    options: {
      role: { cfo: 'Director financiero / CFO', ap_manager: 'Responsable de cuentas a pagar', controller: 'Controller / Jefe administración', founder_ceo: 'Fundador / CEO', accountant_asesoria: 'Asesoría / Despacho contable', bookkeeper: 'Contable interno', other: 'Otro' },
      companySize: { '1-9': '1-9 empleados', '10-49': '10-49 empleados', '50-249': '50-249 empleados', '250+': '250+ empleados' },
      volume: { lt_50: 'Menos de 50 facturas/mes', '50_150': '50-150 facturas/mes', '150_300': '150-300 facturas/mes', '300_1000': '300-1.000 facturas/mes', '1000_plus': 'Más de 1.000 facturas/mes' },
      erp: { holded: 'Holded', quickbooks: 'QuickBooks', xero: 'Xero', sage50: 'Sage 50', sage200: 'Sage 200', a3: 'A3 ERP', sap: 'SAP', quipu: 'Quipu', anfix: 'Anfix', contasol: 'ContaSol', excel_none: 'Excel / Ninguno', other: 'Otro' },
      pain: { manual_entry_time: 'Demasiado tiempo en entrada manual', pricing_errors: 'Errores de precios en facturas', duplicate_payments: 'Pagos duplicados', audit_compliance: 'Auditoría / cumplimiento', growth_scaling: 'Escalar el equipo de AP', fraud_risk: 'Riesgo de fraude de proveedor' },
    },
  },
  validation: { required: 'Obligatorio', email: 'Email no válido', minLength: 'Mínimo {n} caracteres', phone: 'Teléfono no válido' },
  langSelector: { label: 'Idioma', es: 'Español', en: 'English', ca: 'Català' },
};
